import '../stylesheets/wiktionary.scss';

window.components = {
  ...window.components,
  'ClipText': require('../components/ClipText'),
  'FindErrorsEditor': require('../components/FindErrorsEditor'),
  'Playlist': require('../components/Playlist'),
  'TextEditor': require('../components/TextEditor'),
  'CorrectedWordCounter': require('../components/CorrectedWordCounter'),
  'WordCounter': require('../components/WordCounter'),
  'CodeEditor': require('../components/CodeEditor')
}

window.mountComponents(window.components);

window.site = {
  ...window.site || {},
  wordDefinition: {
    init() {
      document.querySelectorAll('.diff .unchanged, .diff .ins, .dictation .unchanged, .dictation .ins').forEach(element => {
        ['mouseenter', 'focus'].forEach(function(event){
          element.removeEventListener(event, site.wordDefinition.show);
          element.addEventListener(event, site.wordDefinition.show);
        });
      });
    },
    hideExistingDefinitions() {
      document.querySelectorAll('.js-tooltip-element[data-show]').forEach(element => {
        element.parentElement.dispatchEvent(new Event('mouseleave'));
      });
    },
    getWord(element) {
      return element.hasAttribute('data-word') ? element.dataset.word : (element.querySelector('span') || element.querySelector('ins')).textContent;
    },
    excludedWord(element) {
      const word = site.wordDefinition.getWord(element);
      return !!(word.match(new RegExp(`^(${gon.specialCharRegex})$`, 'mgi')) || word.match(new RegExp(`^(${gon.newSentenceCharRegex})$`, 'mgi')));
    },
    getDefinition(element) {
      const word = site.wordDefinition.getWord(element);
      fetch(`/api/v1/definition.html?value=${word}`)
        .then(response => response.text())
        .then(data => {
          const tooltip = element.querySelector('.js-tooltip-element');

          if (data && data.length) tooltip.querySelector('.content').innerHTML = data;
          else tooltip.querySelector('.content').innerHTML = `<div class="text-center p-3"><i class='fas fa-times text-danger text-2xl'></i><p class="mt-2 text-base leading-tight">Aucune définition trouvée.</p></div></div>`

          if (tooltip.hasAttribute('data-show')) element.dispatchEvent(new Event('mouseenter'));
        });
    },
    show(event) {
      if (site.wordDefinition.excludedWord(event.target)) return;

      event.target.classList.add('js-tooltip');

      if (!event.target.querySelector('.js-tooltip-element')) {
        let contentWidth = 'auto';
        if (event.target.classList.contains('relative')) {
          contentWidth = `${window.innerWidth > (448 + 20 * 2) ? 448 : window.innerWidth - 20 * 2}px`;
        }
        event.target.innerHTML += `<div class='js-tooltip-element bg-white arrow-grey-light z-50' style="padding: 0 !important;"><div class='content bg-white max-w-md overflow-y-auto overflow-x-hidden' style='max-height: 50vh; width: ${contentWidth}'><div class="text-center p-3"><i class='fas fa-spinner-third fa-spin text-2xl'></i><p class="mt-2 text-base leading-tight">Chargement de la <br />définition...</p></div></div><div class='js-tooltip-arrow' data-popper-arrow></div></div>`;
        window.site.tooltips.init([event.target], [0, 0], 500, () => {
          site.wordDefinition.hideExistingDefinitions();
        });

        site.wordDefinition.hideExistingDefinitions();

        site.wordDefinition.getDefinition(event.target);

        event.target.dispatchEvent(new Event('mouseenter'));
      } else {
        site.wordDefinition.hideExistingDefinitions();
      }
    },
  }
};

window.site.wordDefinition.init();

document.addEventListener('DOMContentLoaded', () => {
  window.site.wordDefinition.init();
});

document.addEventListener('turbo:load', () => {
  window.site.wordDefinition.init();
});
